import { mappers } from './utils';
import { ICheckPublishParams, ICheckPublishSuccess, TCheckPublishResult } from './types';
import { EPublishOfferErrorCode } from '../../redux/reducers';
import { THeaders } from '../../types/request';
import { fetchCheckPublish } from '../../repositories/monolith-python/v1/check-publish';

export async function checkPublish(params: ICheckPublishParams): Promise<TCheckPublishResult> {
  const { httpApi, logger, telemetryService, parameters, subdomain } = params;

  const headers: THeaders = [['Content-Type', 'application/json']];

  const requestConfig = {
    headers,
  };

  try {
    const response = await fetchCheckPublish({
      httpApi,
      parameters,
      config: { requestConfig, subdomain },
      mappers,
    });

    telemetryService.increment('check-publish-request.success');

    return response as ICheckPublishSuccess;
  } catch (error) {
    logger.error(error, {
      description: 'Запрос check-publish',
      degradation: 'Пользователь не может разместить объявление',
    });

    telemetryService.increment('check-publish-request.fail');

    return {
      success: false,
      payload: {
        errorCode: EPublishOfferErrorCode.fatalError,
      },
    };
  }
}
